export default __webpack_public_path__ + "static/media/premiere-card.ab4a5685.png";